import React, { Component, Fragment } from "react";
import Modal from "../../Modal";
import Input from "../../Resources/Forms/Input";
import {
	_findArray,
	_validateAccountNumber,
	_cloneArray,
	_cloneObject,
	_formatCurrency,
} from "../../Utils/helpers";
import TextArea from "../../Resources/Forms/TextArea";
import Button from "../../Resources/Forms/Button";
import { bank_names } from "../../Pipeline/StaticData";
import InputDropdown from "../../Resources/Forms/InputDropdown";
import { POST, GET } from "../../Utils/api";
import withAppData from "../../HOC/withAppData";
import localForage from "localforage";
import { oran_key } from "../../app-config";
import FirstTimeOrder from "../Map/FirstTimeOrder";
import OrderProcessingDetails from "../Map/OrderProcessingDetails";
import "../../Styles/Pages/newdriverreco.scss";
import OtpInput from "react-otp-input";
import warningCircle from "../../Images/warning-circle.svg";
import uploadIcon from "../../Images/upload-icon.svg";
import confirmPayIcon from "../../Images/confirmpay-icon.svg";
import dangerAlertIcon from "../../Images/danger-alert.svg";
import timer from "../../Images/Timer.svg";
import Loading from "../../Loaders/Loading";
import DeliveryOtp from "./DeliveryOtp";
import Timer from "./Retailtimer";

class ChangeOrderStatus extends Component {
	constructor(props) {
		super(props);
		this.cancelReasonRef = React.createRef();
		this.hiddenFileInput = React.createRef();
		this.state = {
			bankNames: this.props.context.role
				.toLowerCase()
				.includes("reseller van driver")
				? [
					{
						name: "Select bank name",
						value: "",
					},
					{ name: "Zenith Bank", value: "1016234225" },
					{ name: "GTBank", value: "0463114640" },
					{ name: "Globus", value: "1000029222" },
				]
				: bank_names,
			payBankNames: bank_names,
			bankName: "",
			paymentReference: "",
			payeeName: "",
			payeeBankName: "",
			payeeAccountNumber: "",
			waybillNumber: "",
			soNumber: "",
			accountNumber: "",
			assignTo: {},
			comment: "",
			isDriver: ["reseller biker", "reseller van driver"].includes(
				this.props.context.role.toLowerCase(),
			),
			isFinance: ["finance", "finance reseller"].includes(
				this.props.context.role.toLowerCase(),
			),
			isWarehouse: ["warehouse", "store manager"].includes(
				this.props.context.role.toLowerCase(),
			),
			isCallCenter: ["call center", "retail scout executive"].includes(
				this.props.context.role.toLowerCase(),
			),
			isOrderVerificationTeam: this.props.context.role
				.toLowerCase()
				.includes("order verification team"),
			paymentMode: "",
			cancelReasons: [
				{
					name: "Select Reason",
					value: "",
				},
				{
					name: "Customer did not place the order",
					value: "Customer did not place the order",
				},
				{ name: "Wrong SKU", value: "Wrong SKU" },
				{ name: "High Price", value: "High Price" },
				{ name: "Duplicate Order", value: "Duplicate Order" },
				{
					name: "Customer wants to place a different order",
					value: "Customer wants to place a different order",
				},
				{ name: "Issue with Delivery date", value: "Issue with Delivery date" },
				{ name: "Ordered by mistake", value: "Ordered by mistake" },
				{ name: "Wrong coupon code", value: "Wrong coupon code" },
				{ name: "Out of Stock", value: "Out of Stock" },
				{
					name: "Customer is not interested anymore",
					value: "Customer is not interested anymore",
				},
				{ name: "Area out of coverage", value: "Area out of coverage" },
				{
					name: "Area out of stock point coverage",
					value: "Area out of stock point coverage",
				},
				{ name: "Others", value: "Others" },
			],
			cancelReason: "",
			rtoReasons: [],
			rtoReason: "",
			showDefaultInput: false,
			sendDeliveryOtp: true, //!!this.props.context.isSettingsActivated(28),
			statusImages: [],
			businessBanks: [],
			businessBank: "",
			isMultipro: this.props.context.isMultiProBusiness,
			isFirstTimeOrder: this.props.order.isFirstOrder,
			retailerVirtualAccount: "",
			retailerBankName: "",
			reatailerAccountName: "",
			stockPointId: "",
			MessageSent: false,
			openModal: false,
			closeModal: false,
			showSuccessModal: false,
			showDeliveredOrderModal: false,
			walletPayment: "",
			orderAmount: "",
			omoniPoint: "",
			cashPayment: "",
			isCash: false,
			cashAmount: "",
			isLoading: true,
			showOtpView: false,
			isLoadingCustomerBank: true,
			customerBankData: [],
			bankIndex: 0,
			files: [],
			image: "",
			awaitingPaymentModal: false,
			isFromRetailApp: false,
			countDownTime: "00:03:00",
			countDownTimeinSec: 180,
			counterDone: false,
			resetTimer: false,
			deliveredSuccess: false,
			isCashCollected: false,
			openConfirmModal: true,
		};
		this.start = 0;
		this.deliveryImageRef = React.createRef();
		this.resetTimer = React.createRef();
		this.paymentFileRef = React.createRef();
	}

	getBusinessbank = async () => {
		let businessBanks = await localForage.getItem("BusinessBankListOran");
		if (businessBanks) {
			this.setState({ businessBanks });
		}

		let headers = _cloneObject(this.props.context.jsonHeader);
		headers.headers["APIKEY"] = oran_key;

		businessBanks = await GET(
			`Dataupdate/GetBusinessBankOran?orderId=${this.props.order.Orderid}`,
			headers,
		);
		if (!businessBanks.error) {
			if (businessBanks.BusinessBankDetails) {
				businessBanks = businessBanks.BusinessBankDetails.map(bank => {
					bank.name = bank.BankName;
					bank.value = bank.BankMainCode;
					return bank;
				});

				businessBanks = [
					{
						name: "Select business bank",
						value: "",
					},
					...businessBanks,
				];
				localForage.setItem("BusinessBankListOran", businessBanks);
				this.setState({ businessBanks });
			} else {
				localForage.removeItem("BusinessBankListOran");
			}
		} else {
			this.props.context.showAlert(businessBanks.error.message, "error");
		}
	};

	componentDidMount() {
		console.log("active order", this.props.order)
		this.startapp()
	}

	startapp = () => {
		if (
			this.props.order &&
			this.props.order.OrderSource &&
			(this.props.order.OrderSource.toLowerCase() !== "call center" &&
			this.props.order.OrderSource.toLowerCase() !== "sfa" &&
				this.props.order.OrderSource.toLowerCase() !== "scout")
		) {
			this.setState({
				awaitingPaymentModal: true,
				isFromRetailApp: true,
			});
			// this.clearTimer(this.getDeadTime());
		}

		if ([2, 5].includes(this.props.newStatusId)) {
			const { order } = this.props;
			if (order.TransactionID) {
				this.setState({ paymentMode: "online" });
			} else if (order.OrderPaymentStatus === "Paylater") {
				this.setState({ paymentMode: "paylater" });
			} else {
				this.setState({ paymentMode: "cod" });
				this.props.getStockPoints();
			}
			if (this.state.isMultipro && !this.state.isDriver) {
				this.getBusinessbank();
			}
		}

		if (this.props.newStatusId === 7) {
			this.getRtoReasons();
		}
		this.getRetailerVirtualAccountDetails(this.props.order.Customerid);

		this.setState({ isLoading: true });
		this.getWalletBalance();
		this.getCustomerAccount();
	}

	addFile = (e, key) => {
		try {
			if (e && e.target && e.target.files) {
				let file = e.target.files[0];
				if (file.size > 15000000) {
					this.props.context.showAlert(
						"Image size should not be more than 15mb",
						"error",
					);
					return;
				} else {
					let fileExtension = file.name.split(".").pop().toLowerCase();
					if (
						fileExtension === "png" ||
						fileExtension === "jpeg" ||
						fileExtension === "jpg"
					) {
						let image = {
							file: file,
							url: window.URL.createObjectURL(file),
							pos: Math.random(),
						};
						this.setState({ [key]: image });
					} else {
						this.props.context.showAlert(
							`.${fileExtension} images are not allowed`,
							"error",
						);
						return;
					}
				}
			}
		} catch (error) { }
	};

	removeFile = async key => {
		this.state[key] && window.URL.revokeObjectURL(this.state[key].url);
		this.setState({ [key]: null });
	};

	requirePayment = flag => {
		if (flag === 1) {
			return (
				this.props.newStatusId === 2 ||
				(this.props.newStatusId === 5 &&
					this.props.order.OrderPaymentStatus &&
					(this.props.order.OrderPaymentStatus.toLowerCase() === "postpaid" ||
						this.props.order.OrderPaymentStatus.toLowerCase() === "paylater"))
			);
		}
		return (
			(this.props.newStatusId === 2 && this.state.paymentMode !== "cod") ||
			(this.props.newStatusId === 5 &&
				this.props.order.OrderPaymentStatus &&
				(this.props.order.OrderPaymentStatus.toLowerCase() === "postpaid" ||
					this.props.order.OrderPaymentStatus.toLowerCase() === "paylater"))
		);
	};
	selectBankNames = evt => {
		const bankDetails = _findArray(
			this.state.bankNames,
			"value",
			evt.target.value,
		);
		this.setState({
			accountNumber: bankDetails.value,
			bankName: bankDetails.name,
		});
	};
	selectedStockPoints = e => {
		let selectedStockPoint = _findArray(
			this.props.stockPointDetails,
			"value",
			Number(e.target.value || 0),
		);
		this.setState({
			stockPointId: e.target.value,
			selectedStockPoint: selectedStockPoint,
			//confirmstockPoint: e.target.value ? true : false,
		});
	};

	getWalletBalance = async () => {
		if (!this.state.isCashCollected) {
			// const url = !this.state.isFromRetailApp
			// 	? `OmniPay/CheckWalletBalanceSufficiency?orderId=${this.props.order.Orderid}`
			// 	: `OmniPay/GetPaymentDetailsForDriverCashConfirmation?orderId=${this.props.order.Orderid}`;
			const url = `OmniPay/CheckWalletBalanceSufficiency?orderId=${this.props.order.Orderid}`;
			let result = await GET(url);
			if (!result.error) {
				// this.props.order.OrderSource.toLowerCase() == "call center"
				// ?
				this.setState({
					walletPayment: result.Data.WalletBalance > 0 ? result.Data.WalletBalance : 0,
					orderAmount: result.Data.OrderAmount,
					omoniPoint: result.Data.OmoniPoint,
				});
				// : this.setState({
				// 		walletPayment: result.AmountFromWallet,
				// 		orderAmount: result.OrderAmount,
				// 		cashAmount: result.CashAmountToBeCollected,
				//   });
			} else {
				this.setState({
					walletPayment: "",
					orderAmount: this.props.order.TotalOrderValue,
					cashAmount: "",
					omoniPoint: "",
				});
			}
		}
		this.setState({ isLoading: false });
	};

	getCustomerAccount = async () => {
		let result = await GET(
			`OmniPay/GetCustomerOmniPayWalletAccountDetails?customerId=${this.props.order.Customerid}`,
		);
		if (!result.error) {
			this.setState({
				customerBankData: result.Data.AccountDetails,
			});
			this.setState({ isLoadingCustomerBank: false });
		}
		// else {
		// 	console.log("error fetching customer bank");
		// 	this.props.context.showAlert(result.error.message, "error");
		// 	this.setState({ awaitingPaymentModal: false });
		// 	this.props.close();
		// }
	};

	initiateCloseOrder = async () => {
		Interface.showToast('close_web_browser');
		if (this.state.isFromRetailApp) {
			await POST(
				`OmniPay/RejectDriverDisburseCash?orderId=${this.props.order.Orderid}`,
			);
		}

		// this.props.close();
		await GET(`Movam/SendCloseEventToMovam?orderId=${this.props.order.Orderid}`,);
		window.location.reload();
	};

	createData = () => {
		return {
			OrderId: this.props.order.Orderid,
			AmountFromWallet:
			Number(this.state.omoniPoint) + Number(this.state.cashAmount) >=
			Number(this.state.orderAmount)
				? 0
				: Number(this.state.orderAmount) -
				  (Number(this.state.cashAmount) + Number(this.state.omoniPoint)),
			AmountCollectedByDriver: Number(this.state.cashAmount),
			IsAmountCollectedByDriver:
				Number(this.state.cashAmount) > 0 ? true : false,
			AppPaymentOriginatedFrom: 1,
			OrderAmount: this.state.orderAmount,
			OmoniPoint: this.state.omoniPoint,
		};
	};
	createFormData = () => {
		return {
			orderId: this.props.order.Orderid,
			orderStatusId: this.props.order.OrderStatusID || 0,
			file: this.state.files[0],
		};
	};

	async initiatePayment() {
		debugger;
		const data = this.createData();
		const formData = this.createFormData();
		this.props.deliveredData(data, formData);
		if (
			// this.props.order.OrderSource.toLowerCase() === "call center" ||
			// !this.state.isFromRetailApp
			!this.state.isCashCollected
		) {
			const initiatePayment = await POST(
				"OmniPay/InitiateOrderPaymentByDriver",
				data,
			);
			if (!initiatePayment.error) {
				this.setState(this.props.toOtpPage(true));
				this.setState(this.props.showOtpView(true));
			} else {
				this.props.context.showAlert(initiatePayment.error.message, "error");
			}
		} else {
			const initiatePayment = await POST(
				`OmniPay/DriverCashConfirmation?orderId=${this.props.order.Orderid}&cashAmoutConfirmed=${this.state.cashAmount}`,
			);
			if (!initiatePayment.error) {
				if (this.state.cashAmount === this.state.orderAmount) {
					this.setState(this.props.toOtpPage(true));
					this.setState(this.props.showOtpView(true));
				} else {
					this.setState(this.props.showOtpView(true));
				}
			} else {
				this.props.context.showAlert(initiatePayment.error.message, "error");
			}
		}
	}

	render() {
		const { newStatusId } = this.props;
		return (
			<Fragment>
				{this.props.order.OrderStatusID === 224 ||
					this.props.order.OrderStatusID === 219 ? (
					<>
						{
							// modelStatus &&
							//  <ConfirmModal
							//      close={() =>this.handleConfirmModel()}
							//      header={`Are you sure you want to deliver this order.`}
							//      confirm={() => this.changeOrderStage()}
							//      confirmText={"Yes"}
							//      cancelText={"No"}
							//      //hideCancelBtn={true}
							//  />

							<Modal
								width={"400px"}
								header={`Are you sure you want to deliver this order.`}
								closeModal={
									this.props.close ||
									(() => this.setState({ openConfirmModal: false }))
								}
							>
								<div
									style={{ textAlignVertical: "center", textAlign: "center" }}
								>
									<Button
										type={"primary"}
										text={"Proceed anyway"}
										loading={this.state.changingOrderStage}
										onClick={() => {
											this.changeOrderStage();
										}}
									/>
								</div>
							</Modal>
						}
					</>
				) : this.state.awaitingPaymentModal ? (
					<Modal
						width={"440px"}
						header={"Awaiting Payment"}
						closeModal={() => {
							this.setState({
								awaitingPaymentModal: false,
								isLoading: true,
								isFromRetailApp: true,
								isCashCollected: false,
								countDownTimeinSec: 0,
							});
							// this.props.toOTPVerify(false)
							this.getCustomerAccount();
							this.getWalletBalance();
						}}
					>
						<div className="delivery-otp-pin">
							{this.state.counterDone ? (
								<img src={confirmPayIcon} alt="confirmpay" />
							) : (
								<div className="delivery-otp-pin-loader"></div>
							)}
							<div className="delivery-otp-pin-text">
								<p>Awaiting Payment</p>
								<p>Please wait as retailer makes Payment</p>
							</div>
							<div className="delivery-otp-pin-timer">
								<img src={timer} alt="timer" />
								{/* <span>{this.state.countDownTime}</span> */}
								{this.state.awaitingPaymentModal && (
									<Timer
										order={this.props.order}
										timerDesign={this.state.countDownTime}
										timeInSecs={this.state.countDownTimeinSec}
										doneWithCounter={val =>
											this.setState({
												counterDone: val,
												resetTimer: false,
											})
										}
										closeModal={() =>
											this.setState({
												awaitingPaymentModal: false,
												countDownTimeinSec: 0,
											})
										}
										reset={this.state.resetTimer}
										isCashCollected={val =>
											this.setState({ isCashCollected: val })
										}
										showModal={this.state.awaitingPaymentModal}
										setToSuccessPage={() => {
											this.setState({
												awaitingPaymentModal: false,
												countDownTimeinSec: 0,
											});
											// this.setState({ deliveredSuccess: true });
											const data = {
												cashAmount: this.state.cashAmount,
												omoniPoint: this.state.omoniPoint,
												orderAmount: this.state.orderAmount,
											};
											this.props.showDeliveredSuccess(data, true);
										}}
										setToConfirmPaymentPage={data => {
											this.setState({ isFromRetailApp: true });
											this.setState({
												walletPayment: data.WalletPayment,
												orderAmount: data.AmountPayable,
												cashAmount: data.CashAmount,
												omoniPoint: Number(data.OmoniPoint) || 0,
											});
											this.setState({
												awaitingPaymentModal: false,
												countDownTimeinSec: 0,
											});
										}}
										ShowDriverEnterOTP={(boolState, data) => {
											this.setState({
												awaitingPaymentModal: false,
												countDownTimeinSec: 0,
												walletPayment: data.WalletPayment,
												orderAmount: data.AmountPayable,
												cashAmount: data.CashAmount,
												omoniPoint: Number(data.OmoniPoint) || 0,
											});
											const submitData = this.createData();
											const formData = this.createFormData();
											this.setState(
												this.props.deliveredData(submitData, formData),
											);
											this.setState(this.props.toOtpPage(boolState));
											this.setState(this.props.showOtpView(boolState));
										}}
									/>
								)}
							</div>
							<div className="delivery-otp-pin-btn">
								<Button
									text="Pay for Retailer"
									type="primary"
									onClick={() => {
										this.setState({
											isLoading: true,
											isFromRetailApp: true,
											awaitingPaymentModal: false,
											countDownTimeinSec: 0,
										});
										this.getWalletBalance();
										this.getCustomerAccount();
									}}
									disabled={!this.state.counterDone}
								/>
							</div>

							{this.state.counterDone && (
								<div className="delivery-otp-pin-bottomtext">
									<p
										onClick={() =>
											this.setState({
												resetTimer: true,
												counterDone: false,
											})
										}
									>
										Request extra time for the retailer?
										<span> More Time</span>
									</p>
								</div>
							)}
						</div>
					</Modal>
				) : (
					<>
						<Modal
							header={
								newStatusId === 2 ? "Confirm Order" : "Change Order Status"
							}
							width={"500px"}
							// goBack={() => null}
							// closeModal={this.props.close}
							closeModal={async () => {
								Interface.showToast('close_web_browser');
								await GET(`Movam/SendCloseEventToMovam?orderId=${this.props.order.Orderid}`,);
								window.location.reload()
							}}
						>
							{this.props.context.hasPermission(395, 3) &&
								this.state.isDriver &&
								this.state.isFirstTimeOrder &&
								this.props.newStatusId === 5 ? (
								<FirstTimeOrder
									orderDetails={this.props.order}
									setFirstTimeOrder={flag => {
										this.setState({ isFirstTimeOrder: false }, () => {
											if (flag === 1)
												this.props.changeStatus(
													this.props.order,
													"Cancelled",
													6,
												);
										});
									}}
									closeModal={this.props.close}
									getOrders={this.props.getOrders}
									changeStatus={this.props.changeStatus}
									context={this.props.context}
									setShowImageTagging={this.props.setShowImageTagging}
									imageTagData={this.props.imageTagData}
								/>
							) : this.props.context.hasPermission(394, 3) &&
								(this.state.isCallCenter || this.state.isFinance) &&
								this.state.isFirstTimeOrder &&
								this.props.newStatusId === 2 ? (
								<OrderProcessingDetails
									orderDetails={this.props.order}
									setFirstTimeOrder={flag => {
										this.setState({ isFirstTimeOrder: false }, () => {
											if (flag === 1) {
												this.props.changeStatus(
													this.props.order,
													"Order Confirmed",
													2,
												);
											}
										});
									}}
									context={this.props.context}
									closeModal={this.props.close}
									setShowImageTagging={this.props.setShowImageTagging}
									imageTagData={this.props.imageTagData}
								/>
							) : (
								<Fragment>
									<div>
										<>
											{this.props.order && (
												// (this.props.order.OrderSource.toLowerCase() ===
												// "call center" &&
												<div className="driverreco">
													{!this.state.isLoading ? (
														<>
														<div className="driverreco-top">
															<p>Amount Payable</p>
															{!this.state.isLoading ? (
																<p>
																	{_formatCurrency(
																		this.state.orderAmount || 0,
																	)}
																</p>
															) : (
																<Loading type="circle" />
															)}
														</div>
														{Number(this.state.cashAmount) &&
														Number(this.state.omoniPoint) > 0 &&
														Number(this.state.cashAmount) +
															Number(this.state.omoniPoint) +
															Number(this.state.walletPayment) >=
															Number(this.state.orderAmount) ? (
															<div className="driverreco-alert">
																<img
																	src={warningCircle}
																	alt="warning-circle"
																/>
																<span>
																	Confirm cash of {"  "}
																	<strong
																		style={{
																			fontWeight: "bold",
																			fontSize: "15px",
																		}}
																	>{`${_formatCurrency(
																		this.state.cashAmount,
																	)}`}</strong>
																	{"  "} was paid.
																</span>
															</div>
															) : Number(this.state.cashAmount) &&
															Number(this.state.cashAmount) +
																  Number(this.state.walletPayment) >=
																  Number(this.state.orderAmount) ? (
															  <div className="driverreco-alert">
																  <img
																	  src={warningCircle}
																	  alt="warning-circle"
																  />
																  <span>
																	  Confirm cash of {"  "}
																	  <strong
																		  style={{
																			  fontWeight: "bold",
																			  fontSize: "15px",
																		  }}
																	  >{`${_formatCurrency(
																		  this.state.cashAmount,
																	  )}`}</strong>
																	  {"  "} was paid.
																  </span>
															  </div>
														  ) : Number(this.state.omoniPoint) > 0 &&
														  Number(this.state.walletPayment) +
														  Number(this.state.omoniPoint) >=
														  Number(this.state.orderAmount) ? (
															  <div className="driverreco-alert">
																  <img
																	  src={warningCircle}
																	  alt="warning-circle"
																  />
																  <span>
																	  {`Retailer has sufficient balance. Click confirm to proceed.`}
																  </span>
															  </div>
														) : Number(this.state.walletPayment) >=
														  Number(this.state.orderAmount) ? (
															<div className="driverreco-alert">
																<img
																	src={warningCircle}
																	alt="warning-circle"
																/>
																<span>
																	{`Retailer has sufficient balance. Click confirm to proceed.`}
																</span>
															</div>
															) : Number(this.state.omoniPoint) > 0 &&
															  Number(this.state.orderAmount) >
																	Number(this.state.walletPayment) +
																		Number(this.state.omoniPoint) ? (
																<div className="driverreco-inputs-alertdanger">
																	<img
																		src={dangerAlertIcon}
																		alt="danger-alert"
																	/>
																	<span>
																		Insufficient Balance. Request Retailer to
																		transfer{" "}
																		<strong>{`${_formatCurrency(
																			Number(this.state.orderAmount) -
																				(Number(this.state.cashAmount) +
																					Number(this.state.omoniPoint) +
																					Number(this.state.walletPayment)),
																		)}`}</strong>{" "}
																		balance or pay with cash balance.
																	</span>
																</div>
														) : (
															<div className="driverreco-inputs-alertdanger">
																<img
																	src={dangerAlertIcon}
																	alt="danger-alert"
																/>
																<span>
																	Insufficient Balance. Request Retailer to
																	transfer{" "}
																	<strong>{`${_formatCurrency(
																		Number(this.state.orderAmount) -
																			(Number(this.state.cashAmount) +
																				Number(this.state.walletPayment)),
																	)}`}</strong>{" "}
																	balance or pay with cash balance.
																</span>
															</div>
														)}
													</>
													) : (
														<Loading type="circle" />
													)}
													<div className="driverreco-linethrough"></div>

													<div className="driverreco-inputs">
														<p className="driverreco-inputs-title">
															Payment Method
														</p>

														<div className="driverreco-inputs-one">
															<Input
																label={"Wallet Payment"}
																placeholder={_formatCurrency(
																	Number(this.state.omoniPoint) > 0
																		? Number(this.state.omoniPoint)
																		: Number(this.state.cashAmount > 0) &&
																	Number(this.state.cashAmount > 0) &&
																		Number(this.state.cashAmount) <
																		Number(this.state.orderAmount)
																		? Number(this.state.orderAmount) -
																		Number(this.state.cashAmount)
																		// : Number(this.state.orderAmount)
																		// ? Number(this.state.orderAmount)
																		: 0,
																)}
																onChange={() => null}
																value={""}
																disabled
																errorText={
																	Number(this.state.cashAmount) +
																	Number(this.state.omoniPoint) +
																		Number(this.state.walletPayment) <
																		Number(this.state.orderAmount)
																		? true
																		: false
																}
															/>
														</div>
														<div className="driverreco-inputs-refresh">
															<span
																className={
																	this.state.isCashCollected
																		? "driverreco-inputs-refresh-inactive"
																		: "driverreco-inputs-refresh-active"
																}
																onClick={() => {
																	if (!this.state.isCashCollected) {
																		this.setState({ isLoading: true });
																		this.getWalletBalance();
																	}
																}}
															>
																{!this.state.isLoading ? (
																	"Refresh Balance"
																) : (
																	<Loading type="circle" />
																)}
															</span>
														</div>
														<div className="driverreco-inputs-two">
															{this.state.isFromRetailApp ? (
																<Input
																	label={"Cash Payment"}
																	placeholder={_formatCurrency(0)}
																	onChange={e => {
																		// const re = /^[0-9\b]+$/;
																		// const re = /^\d+(\.\d{1,2})?$/;
																		// if (
																		// 	e.target.value === "" ||
																		// 	re.test(e.target.value)
																		// ) {
																		// 	this.setState({
																		// 		cashAmount: e.target.value,
																		// 	});
																		// }

																		this.start = e.target.selectionStart;
																		let val = e.target.value;
																		val = val.replace(/([^0-9.]+)/, "");
																		val = val.replace(/^(0|\.)/, "");
																		const match = /(\d{0,30})[^.]*((?:\.\d{0,2})?)/g.exec(
																			val,
																		);
																		const value = match[1] + match[2];
																		e.target.value = value;
																		this.setState({ cashAmount: value });
																		if (val.length > 0) {
																			e.target.value = Number(value).toFixed(2);
																			e.target.setSelectionRange(
																				this.start,
																				this.start,
																			);
																			this.setState({
																				cashAmount: Number(value).toFixed(2),
																			});
																		}
																	}}
																	value={this.state.cashAmount}
																	disabled={this.state.isCashCollected}
																/>
															) : (
																<Input
																	label={"Cash Payment"}
																	placeholder={_formatCurrency(0)}
																	onChange={e => {
																		// const re = /^[0-9\b]+$/;
																		// const re = /^\d+(\.\d{1,2})?$/;
																		// if (
																		// 	e.target.value === "" ||
																		// 	re.test(e.target.value)
																		// ) {
																		// 	this.setState({
																		// 		cashAmount: e.target.value,
																		// 	});
																		// }

																		this.start = e.target.selectionStart;
																		let val = e.target.value;
																		val = val.replace(/([^0-9.]+)/, "");
																		val = val.replace(/^(0|\.)/, "");
																		const match = /(\d{0,30})[^.]*((?:\.\d{0,2})?)/g.exec(
																			val,
																		);
																		const value = match[1] + match[2];
																		e.target.value = value;
																		this.setState({ cashAmount: value });
																		if (val.length > 0) {
																			e.target.value = Number(value).toFixed(2);
																			e.target.setSelectionRange(
																				this.start,
																				this.start,
																			);
																			this.setState({
																				cashAmount: Number(value).toFixed(2),
																			});
																		}
																	}}
																	value={this.state.cashAmount}
																	disabled={
																		this.state.isCashCollected
																		// || (!this.state.isFromRetailApp &&
																		// this.state.walletPayment <
																		// 	this.state.orderAmount
																		// 	? false
																		// 	: true)
																	}
																/>
															)}
														</div>
													</div>

													<div className="driverreco-paymentbox">
														<div className="driverreco-paymentbox-top">
															<p>Payment Account</p>
															<p>
																Retailer makes payment to the account below.
															</p>
														</div>
														{
															// this.props.order.OrderSource.toLowerCase() ===
															//  "call center"
															!this.state.isCashCollected && (
																<div className="driverreco-paymentbox-bottom">
																	<div className="driverreco-paymentbox-bottom-box">
																		<p>Account Number</p>
																		<p>
																			{!this.state.isLoadingCustomerBank ? (
																				this.state.customerBankData[
																				this.state.bankIndex
																				]["AccountNumber"]
																			) : (
																				<Loading type="circle" />
																			)}
																		</p>
																	</div>

																	<div className="driverreco-paymentbox-bottom-box">
																		<p>Bank Name</p>
																		<p>
																			{!this.state.isLoadingCustomerBank ? (
																				this.state.customerBankData[
																				this.state.bankIndex
																				]["BankName"]
																			) : (
																				<Loading type="circle" />
																			)}
																		</p>
																	</div>

																	<div className="driverreco-paymentbox-bottom-box">
																		<p>Account Name</p>
																		<p>
																			{!this.state.isLoadingCustomerBank ? (
																				this.state.customerBankData[
																				this.state.bankIndex
																				]["AccountName"]
																			) : (
																				<Loading type="circle" />
																			)}
																		</p>
																	</div>
																</div>
															)
														}
													</div>

													<div>
														{this.state.image && (
															<span
																className="driverreco-cancelimage"
																onClick={() =>
																	this.setState({
																		files: [],
																		image: "",
																	})
																}
															>
																x
															</span>
														)}
														<div
															onClick={() =>
																this.hiddenFileInput.current.click()
															}
															className="driverreco-uploadbox"
															style={{ marginBottom: "100px" }}
														>
															<input
																type="file"
																accept=".jpg,.jpeg,.png"
																// multiple
																ref={this.hiddenFileInput}
																style={{ display: "none" }}
																onChange={e => {
																	this.setState({
																		// files: [...e.target.files],
																		files: e.target.files,
																	});
																	if (e.target.files && e.target.files[0]) {
																		let reader = new FileReader();
																		reader.onload = event => {
																			this.setState({
																				image: event.target.result,
																			});
																		};
																		reader.readAsDataURL(e.target.files[0]);
																	}
																}}
															/>
															{this.state.image ? (
																<>
																	<img
																		alt=""
																		id="target"
																		src={this.state.image}
																		className="driverreco-uploadbox-img"
																	/>
																</>
															) : (
																<>
																	<div className="driverreco-uploadbox-main">
																		<img src={uploadIcon} alt="upload" />
																		<div className="driverreco-uploadbox-main-textbox">
																			<p>Upload Proof of Payment</p>
																			<p>Snap to upload image</p>
																			<div className="row">
																				{/* {this.state.files &&
                                                                            this.state.files.map((val, i) => (
                                                                                <p key={i}>{val.name}</p>
                                                                            ))} */}
																				<p>
																					{this.state.files.length > 0 &&
																						this.state.files[0].name}
																				</p>
																			</div>
																		</div>
																	</div>

																	<div className="driverreco-uploadbox-retakeimage">
																		<p>Retake image</p>
																	</div>
																</>
															)}
														</div>
													</div>

													<div className="modal-submit">
														<div
															style={{
																position: "relative",
																margin: "10px 0 10px auto",
															}}
														>
															<Button
																text="Reject"
																type="default"
																onClick={() => this.initiateCloseOrder()}
																loading={""}
																disabled={this.state.isLoading}
															/>
														</div>
														<div
															style={{
																position: "relative",
																margin: "10px auto 10px 15px",
															}}
														>
															<Button
																disabled={
																	this.state.isLoading ||
																	// Number(this.state.cashAmount) >
																	// 	Number(this.state.orderAmount) ||
																	// Number(this.state.walletPayment) +
																	// 	Number(this.state.cashAmount) <
																	// 	Number(this.state.orderAmount) ||
																	(Number(this.state.omoniPoint) > 0 &&
																		Number(this.state.cashAmount) +
																			Number(this.state.omoniPoint) >
																			Number(this.state.orderAmount)) ||
																	(Number(this.state.cashAmount) &&
																		Number(this.state.cashAmount) >
																			Number(this.state.orderAmount)) ||
																	(Number(this.state.cashAmount) || 0) +
																		(Number(this.state.omoniPoint) || 0) +
																		(Number(this.state.walletPayment) || 0) <
																		Number(this.state.orderAmount)
																}
																text="Confirm"
																type="primary"
																// onClick={() => {
																//  this.setState({showOtpView: true
																// })}
																onClick={() => {
																	this.initiatePayment();
																	// this.initiateOtp();
																	// this.setState(this.props.showOtpView(true));
																}}
																loading={""}
															/>
														</div>
													</div>
												</div>
											)}

											{this.state.openModal && (
												<Modal
													header={"Order Confirmation"}
													width="350px"
													minHeight="300px"
													isSmall={true}
													closeModal={() =>
														this.setState({
															openModal: !this.state.openModal,
														})
													}
												>
													<div className="driverorderconfirm">
														<div className="driverorderconfirm-top">
															<div className="driverorderconfirm-top-image">
																<img src={confirmPayIcon} alt="hdjd" />
															</div>

															<div className="driverorderconfirm-top-textbox">
																<p>
																	You are about to pay{" "}
																	<span>{_formatCurrency(47400)}</span> for{" "}
																	<span>Order ID 322455.</span>
																</p>
															</div>
														</div>

														<div className="driverorderconfirm-bottom">
															<p>Enter OTP to confirm</p>
															<div className="driverorderconfirm-bottom-otpfield">
																<OtpInput
																	onChange={""}
																	numInputs={4}
																	inputStyle={"form__input"}
																	isInputNum={true}
																	separator={<span> </span>}
																	value={""}
																	errorStyle="form__input__error"
																/>

																<p>Wrong PIN!</p>
															</div>
														</div>

														<div className="modal-submit">
															<Button
																text="Verify OTP"
																type="primary"
																onClick={() =>
																	this.setState({
																		showSuccessModal: !this.state
																			.showSuccessModal,
																	})
																}
																loading={""}
															/>
														</div>
													</div>
												</Modal>
											)}

											{this.state.showOtpView && (
												<div className="order-processing">
													<DeliveryOtp
														order={this.props.order}
														close={() => this.setState({ showOtpView: false })}
														successOtpVerify={this.successOtpVerify()}
														source={"Delivered"}
														sourceId={this.props.newStatusId}
														retailerPhoneNumber={this.props.order.CustomerPhone}
														retailerStoreName={this.props.order.CustomerName}
													/>
												</div>
											)}

											{/* {(
												// this.props.deliveredSuccess ||
												this.state.deliveredSuccess) && (
												<SuccessModal
													close={() => {
														// this.setState({
														//  showSuccessModal: false,
														// })
														// this.props.history.push({
														// 	pathname: "/oms-shipments",
														// })
														window.location.reload();
													}}
													text={"Order Delivered Successfully"}
													subText={"Congratulations, Shipment Successful."}
													btnText={"Return to shipment"}
													btnType={"default"}
													btnAction={() => {
														// this.props.history.push({
														// 	pathname: "/oms-shipments",
														// })
														window.location.reload();
													}}
													width={"300px"}
												/>
											)} */}
										</>
									</div>
								</Fragment>
							)}
						</Modal>
					</>
				)}
			</Fragment>
		);
	}

	renderCommentBox = () => {
		return (
			<TextArea
				label={"Comment"}
				rows={"2"}
				value={this.state.comment}
				onChange={e => this.setState({ comment: e.target.value })}
			/>
		);
	};

	renderUserAssign = users => {
		let dropdownUsers = users || this.props.users;
		if (this.props.preventAssigningToSameUser && this.props.order) {
			dropdownUsers = dropdownUsers.filter(
				user => user.Userid !== this.props.order.Agentid,
			);
		}
		return (
			<InputDropdown
				options={dropdownUsers}
				label={this.props.order.AgentName ? "Assign To" : "Assign To"}
				withMargin={true}
				isAbsolute
				selectOption={assignTo => {
					this.setState({ assignTo });
				}}
				splitName={true}
				requiredStar={true}
				errorText={
					this.props.preventAssigningToSameUser && dropdownUsers.length === 0
						? `Order can't be reassigned, ${this.props.order.AgentName} is the only user assigned to you`
						: ``
				}
			/>
		);
	};

	changeAccountNumber = e => {
		const value = e.target.value;
		let accountNumberError = _validateAccountNumber(value);
		this.setState({ accountNumber: value, accountNumberError }, () => { });
	};
	changePayeeAccountNumber = e => {
		const value = e.target.value;
		let payeeaccountNumberError = _validateAccountNumber(value);
		this.setState(
			{ payeeAccountNumber: value, payeeaccountNumberError },
			() => { },
		);
	};

	changeOrderStage = async () => {
		let rtoText = "";
		this.setState({ confirmstockPoint: false });
		let rtoData = "";
		const cancelReason = this.state.cancelReason
			? this.state.cancelReason === "Others"
				? this.state.otherCancelReason
				: this.state.cancelReason
			: "";
		const { longitude = "", latitude = "" } = this.props.context.userLocation;
		if (this.state.rtoReason) {
			let rto = this.state.rtoReasons.find(
				rto => rto.value === parseInt(this.state.rtoReason),
			);
			rtoText = rto.name;
			rtoData = {
				orderid: this.props.order.Orderid,
				orderStatusId: 216,
				RTOReasonID: rto.value,
				RTOReason: rto.name,
				Flag: 1,
			};
			//await POST("Store/AddOrderRTOReasons", rtoData);
		}
		const data = {
			stockPointId: this.state.stockPointId || 0,
			NewStage: this.props.newStageName,
			PipelineId: this.props.order.Pipelineid,
			Note:
				this.props.newStatusId === 7
					? this.state.rtoReason
					: this.props.newStatusId === 6
						? cancelReason
						: this.state.comment || "",
			CreatedBy: Number(this.props.context.userId),
			PipelineMasterId: 1,
			soNumber: this.state.soNumber || this.props.order.SOnumber || "",
			OrionTransactionID:
				this.state.transactionId || this.props.order.OrionTransactionID || "",
			waybillNumber:
				this.state.waybillNumber || this.props.order.WaybillNumber || "",
			longitude,
			latitude,
			AssignToAgentID: this.state.assignTo.Userid,
			flag: [5, 7].includes(this.props.order.orderStatusId) ? 1 : 0, //if pre status is rto or delivered then pass 1
			rtoReason: rtoText,
		};
		await this.setState({ changingOrderStage: true });
		if (
			this.requirePayment() &&
			!(this.state.sendDeliveryOtp && this.props.newStatusId === 5)
		) {
			let paymentResponse = this.savePaymentDetails();
			if (paymentResponse.error) {
				this.props.context.showAlert(paymentResponse.error.message, "error");
				this.setState({ changingOrderStage: false });
				return;
			}
		}
		// if (
		//  this.state.assignTo.Userid &&
		//  !(this.state.sendDeliveryOtp && this.props.newStatusId === 5)
		// ) {
		//  let assignResult = await this.assignOrder();
		//  if (assignResult.error) {
		//      this.setState({ changingOrderStage: false });
		//      this.props.context.showAlert("Please try again", "error");
		//      return;
		//  }
		// }

		let result = !(
			this.state.sendDeliveryOtp && [5, 7].includes(this.props.newStatusId)
		)
			? await POST("pipeline/Updatepipeline", data)
			: null;

		if (
			this.props.newStatusId === 7 &&
			this.props.order.PaylaterChildOrderSRId !== 0 &&
			!(this.state.sendDeliveryOtp && [5, 7].includes(this.props.newStatusId))
		) {
			this.rtoChildOrder();
		}

		if (this.state.statusImages && this.state.statusImages.length) {
			this.state.statusImages.map(async image => {
				if (image.addedImage) {
					let imgData = new FormData();
					imgData.append("orderid", this.props.order.Orderid);
					imgData.append("orderstatusid", this.props.newStatusId);
					imgData.append("img", image.addedImage.file);
					imgData.append("type", image.type);
					await POST("store/addorderstatusimage", imgData);
				}
			});
		}

		if (this.state.paymentImage) {
			let paymentImageData = new FormData();
			paymentImageData.append("orderid", this.props.order.Orderid);
			paymentImageData.append("orderstatusid", this.props.newStatusId);
			paymentImageData.append("img", this.state.paymentImage.file);
			await POST("store/addorderstatusimage", paymentImageData);
		}

		this.setState({ changingOrderStage: false });
		if (result && result.error) {
			this.props.context.showAlert(result.error.message, "error");
		} else {
			this.props.close();
			if (
				this.state.sendDeliveryOtp &&
				[5, 7].includes(this.props.newStatusId)
			) {
				let updatePendingOrderPayementPrm = "";
				let assignOrderPrm = "";
				if (this.requirePayment() && this.props.newStatusId === 5)
					updatePendingOrderPayementPrm = this.savePaymentDetailsPrm();
				if (this.state.assignTo.Userid && this.props.newStatusId === 5)
					assignOrderPrm = this.assignOrderPrm();
				this.props.setPipelineFetchPrms(
					assignOrderPrm,
					data,
					updatePendingOrderPayementPrm,
					rtoData,
					this.props.order.PaylaterChildOrderSRId,
				);
				this.props.showOtpView();
			} else {
				this.props.context.showAlert(
					this.props.newStatusId === 2
						? "Order confirmed successfully"
						: this.props.newStatusId === 6
							? "Order cancelled successfully"
							: "Order status changed successfully",
				);
				this.props.getOrders();
			}
		}
	};

	rtoChildOrder = async () => {
		const { longitude = "", latitude = "" } = this.props.context.userLocation;
		let orderDetailTest = await GET(
			`Store/GetOnlineOrders_Retail_details?Orderid=${this.props.order.PaylaterChildOrderSRId}`,
		);
		const data = {
			stockPointId: this.state.stockPointId || 0,
			NewStage: this.props.newStageName,
			PipelineId: orderDetailTest.PipeLineId,
			Note: "Parent Order of this PayLater Order RTO",
			CreatedBy: Number(this.props.context.userId),
			PipelineMasterId: 1,
			soNumber: orderDetailTest.SOnumber || "",
			OrionTransactionID: orderDetailTest.OrionTransactionID || "",
			waybillNumber: orderDetailTest.WaybillNumber || "",
			longitude,
			latitude,
			AssignToAgentID: this.state.assignTo.Userid,
			flag: [5, 7].includes(this.props.order.orderStatusId) ? 1 : 0, //if pre status is rto or delivered then pass 1
			rtoReason: "Parent Order of this PayLater Order RTO",
		};
		await POST("pipeline/Updatepipeline", data);
	};

	savePaymentDetailsPrm() {
		let data;
		if (this.state.paymentMode === "cod") {
			data = {
				OrderId: this.props.order.Orderid,
				TransactionID: "",
				PayeeName: "",
				PayeeBankName: "",
				PayeeAccountNumber: "",
				Amount: this.props.order.TotalPrice,
				AccountNumber: "",
				BankMainCodeOrion: "",
				BankSubCodeOrion: "",
				IsCod: 1,
				Cod: 1,
				orderstatus: this.props.newStatusId,
			};
		} else if (this.state.paymentMode === "paylater") {
			data = {
				OrderId: this.props.order.Orderid,
				TransactionID: "",
				PayeeName: "",
				PayeeBankName: "",
				PayeeAccountNumber: "",
				Amount: this.props.order.TotalPrice,
				AccountNumber: "",
				BankMainCodeOrion: "",
				BankSubCodeOrion: "",
				IsCod: 0,
				Cod: 0,
				orderstatus: this.props.newStatusId,
			};
		} else {
			let businessBank = this.state.businessBanks.find(
				bank => bank.value === this.state.businessBank,
			);

			data = {
				OrderId: this.props.order.Orderid,
				TransactionID: this.state.paymentReference,
				PayeeName: this.state.payeeName,
				PayeeBankName: this.state.payeeBankName,
				BankName: this.state.bankName,
				BankMainCodeOrion: businessBank ? businessBank.BankMainCode : "",
				BankSubCodeOrion: businessBank ? businessBank.BankSubCode : "",
				Amount: this.props.order.TotalPrice,
				AccountNumber: this.state.isDriver
					? this.state.payeeAccountNumber
					: this.state.accountNumber,
				IsCod: 0,
				Cod: 0,
				orderstatus: this.props.newStatusId,
			};
		}
		return data;
	}
	assignOrderPrm() {
		let data = {
			LeadId: this.props.order.leadid,
			PipelineId: this.props.order.Pipelineid,
			AgentId: this.state.assignTo.Userid,
			Type: 4,
			pipelineMasterId: 1,
			Note: this.state.comment || "",
			soNumber: this.state.soNumber || this.props.order.SOnumber || "",
			OrionTransactionID:
				this.state.transactionId || this.props.order.OrionTransactionID || "",
			Stage: this.props.newStatusId,
			orderstatus: this.props.newStatusId,
		};
		return data;
	}
	savePaymentDetails = async () => {
		let data = this.savePaymentDetailsPrm();
		let result = await POST("store/UpdatePendingOrderPayement", data);
		if (!result.error) {
			this.setState({
				paymentReference: "",
				payeeName: "",
				payeeAccountNumber: "",
				payeeBankName: "",
				bankName: "",
				accountNumber: "",
			});
		}
		return result;
	};

	assignOrder = async () => {
		let data = this.assignOrderPrm();

		let result = await POST("pipeline/addPipeline", data);
		return result;
	};

	getRtoReasons = async () => {
		let rtoReasons = await localForage.getItem(
			"OrderStatusChangeReasonsDetails",
		);
		if (rtoReasons && rtoReasons.length) {
			rtoReasons = [
				{
					name: "Select Reason",
					value: "",
				},
				...rtoReasons,
			];
			await this.setState({ rtoReasons: _cloneArray(rtoReasons) });
		}
		let result = await GET(
			`Store/GetOrderStatusChangeReasons?Status=RTO&cacheId=${this.props.context.cacheId}`,
		);
		if (!result.error) {
			rtoReasons = result.OrderStatusChangeReasonsDetails.map(reason => ({
				name: reason.RTOReason,
				value: reason.RTOReasonID,
			}));
			localForage.setItem("OrderStatusChangeReasonsDetails", rtoReasons);
			rtoReasons = [
				{
					name: "Select Reason",
					value: "",
				},
				...rtoReasons,
			];
			this.setState({ rtoReasons });
		}
	};

	isButtonDisabled = () => {
		if (
			!this.props.context.hasPermission(429, 3) &&
			this.props.users.length > 0 &&
			![5, 6, 7, 8].includes(this.props.newStatusId) &&
			!this.state.assignTo.Userid
		) {
			return true;
		}
		if (
			this.requirePayment(1) &&
			this.state.isOrderVerificationTeam &&
			!this.state.stockPointId
		) {
			return true;
		}
		if (
			this.requirePayment() &&
			this.state.paymentMode === "bank" &&
			!(this.state.paymentImage && this.state.paymentImage.url)
		) {
			return true;
		}
		if (
			this.props.newStatusId === 3 &&
			!this.state.waybillNumber &&
			!this.state.isWarehouse
		) {
			return true;
		}
		if (
			this.props.newStatusId === 6 &&
			(!this.state.cancelReason ||
				(this.state.cancelReason === "Others" && !this.state.otherCancelReason))
		) {
			return true;
		}
		if (this.props.newStatusId === 7 && !this.state.rtoReason) {
			return true;
		}
		// if (
		//   this.state.paymentMode === "cod" &&
		//   this.props.newStatusId === 5 &&
		//   this.requirePayment()
		// ) {
		//   return true;
		// }

		return false;
	};

	getRetailerVirtualAccountDetails = async retailerId => {
		const response = await GET(
			`User/GetVirtualAccountDetailsForRetailer?retailerId=${retailerId || 0}`,
		);
		if (response) {
			this.setState({
				retailerVirtualAccount: response.AccountNumber,
				reatailerAccountName: response.AccountName,
				retailerBankName: response.BankName,
			});
		}
	};

	sendSMS = async () => {
		if (!this.state.MessageSent) {
			const response = await POST(`Store/SendPaymentSMSToRetailer`, {
				OrderId: this.props.order.Orderid,
				CustomerId: this.props.order.Customerid,
			});
			if (!response.error) {
				this.setState({
					MessageSent: true,
				});
			}
		}
	};

	addPaymentStatusLog = async isCOD => {
		await POST(`Store/AddPaymentStatusLog`, {
			OrderId: this.props.order.Orderid,
			IsCod: isCOD,
		});
		await GET(
			`payment/GetOrderDetailForOnePipe?orderId=${this.props.order.Orderid}`,
		);
	};

	successOtpVerify = () => {
		//this.setState({ showOtpView: false });
		this.props.context.showAlert("Delivery acknowledged successfully");
		// this.setState({ showOtpView: false });
		this.setState({
			showSuccessModal: true,
		});
	};
}
export default withAppData(ChangeOrderStatus);

